import { useEffect, useState } from "react";
import api, { money, apiErr } from "@/lib/api";
import { MessageCircle, Check } from "lucide-react";
import { toast } from "sonner";

export default function VendorQuotesPage() {
  const [quotes, setQuotes] = useState([]);
  const load = () => api.get("/quotes/recent?limit=100").then((r) => setQuotes(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, []);

  const accept = async (id) => {
    try { await api.post(`/quotes/${id}/accept`); toast.success("Quote accepted"); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  const pending = quotes.filter((q) => q.status === "pending").length;

  return (
    <div data-testid="vendor-quotes-page">
      <div className="mb-6">
        <div className="text-xs font-bold uppercase tracking-widest text-primary">Bids</div>
        <h1 className="font-heading font-black text-4xl tracking-tight flex items-center gap-3">
          Recent Vendor Quotes
          {pending > 0 && <span className="inline-flex items-center justify-center min-w-[26px] h-6 px-2 bg-primary text-primary-foreground text-xs font-bold" data-testid="quotes-pending-count">{pending}</span>}
        </h1>
        <p className="text-muted-foreground text-sm">All incoming vendor bids for active leads · live via WhatsApp, refreshes every 15s.</p>
      </div>

      <div className="border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm" data-testid="vendor-quotes-table">
          <thead><tr className="border-b border-border text-left text-xs uppercase tracking-wide text-muted-foreground">
            <th className="py-3 px-4">Received</th><th className="px-4">Order</th><th className="px-4">Transporter</th><th className="px-4 text-right">Rate</th><th className="px-4">Vehicle</th><th className="px-4">Driver</th><th className="px-4">Status</th><th className="px-4 text-right">Action</th>
          </tr></thead>
          <tbody>
            {quotes.length === 0 && <tr><td colSpan={8} className="p-10 text-center text-muted-foreground">No vendor quotes yet. Share an order on WhatsApp to start collecting bids.</td></tr>}
            {quotes.map((q) => (
              <tr key={q.id} className="border-b border-border last:border-0 hover:bg-muted transition-colors" data-testid={`quote-row-${q.id}`}>
                <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(q.created_at).toLocaleString()}</td>
                <td className="px-4 font-mono-num text-primary">{q.order_number}</td>
                <td className="px-4 font-medium">{q.vendor_name}</td>
                <td className="px-4 text-right font-mono-num font-bold">{money(q.rate)}</td>
                <td className="px-4 font-mono-num text-xs">{q.vehicle_number}</td>
                <td className="px-4 text-xs">{q.driver_name}</td>
                <td className="px-4">
                  <span className={`inline-flex items-center px-2 py-0.5 text-[11px] font-bold uppercase border ${q.status === "accepted" ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400 border-emerald-300 dark:border-emerald-800" : q.status === "rejected" ? "bg-muted text-muted-foreground border-border" : "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400 border-amber-300 dark:border-amber-800"}`}>{q.status}</span>
                </td>
                <td className="px-4 text-right">
                  {q.status === "pending"
                    ? <button onClick={() => accept(q.id)} className="inline-flex items-center gap-1 border border-primary bg-primary text-primary-foreground px-3 py-1 text-xs font-bold uppercase hover:opacity-90 transition-opacity" data-testid={`accept-quote-${q.id}`}><Check className="h-3 w-3" /> Accept</button>
                    : <span className="text-xs text-muted-foreground">—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
